export interface PriceRange {
  min: number;
  max: number;
}

export class Day {
  
  public date: string;
  public hasSlots: boolean;
  public isOpen: boolean;
  public priceRange: PriceRange;
  public workingUntil: string;
  public events: string[] = [];

  constructor(
    obj?: any 
  ) {
    this.date = obj && obj.date || null;
    this.hasSlots = obj && obj.hasSlots || null;
    this.isOpen = obj && obj.isOpen || null;
    this.priceRange = obj && obj.priceRange || null;
    this.workingUntil = obj && obj.workingUntil || null;
    this.events = obj && obj.events || null;
  }
  
}